<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar title="修改邮箱" align="center">
      <!--返回上一层-->
      <router-link slot="left" to="/user/BaseInfo">
        <mu-icon value="keyboard_arrow_left" color="white"   style="margin-top:1vh"  />
      </router-link>

      <!--<mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />-->
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <table style="width:90% ; margin-top:2vh ;  ;" align="center" border="0" >
      <tr>
        <td style="20%" class="title">
  
          新邮箱
        </td>
        <td colspan="2">
          <mu-text-field hintText="gxx@qq.com" type="text" v-model="UserEmail" fullWidth="" style="margin-left:1vh ; width:103% " />
  
        </td>
      </tr>
      <tr>
        <td style="20%" class="title">
          附加码
        </td>
        <td>
          <mu-text-field hintText="2333" type="text" v-model="FJM" fullWidth="" 
          style="margin-left:1vh ; width:98% ; " />
        </td>
        <td style="width:30%">
        
          2232
        </td>
      </tr>
      <tr>
        <td style="20%" class="title">
          验证码
        </td>
        <td>
          <mu-text-field hintText="2333" type="text" v-model="YZM" fullWidth="" style="margin-left:1vh ; width:98% " />
  
        </td>
        <td>
  <mu-raised-button label="获取" primary="" @click="getYZM"  style="font-size:110% ; margin-left:2% ; width:27% ; margin-bottom:3vh" />
        </td>
      </tr>
  
    </table>
  
    <mu-raised-button label="修 改" primary="" @click="Change" v-bind:style="{ width:'90%',height:'50px' }" style="font-size:130% ; margin-top:2vh ;" />
  

    <br />
    <br />
    <br />
    <br />
    <!--弹出框 选择是否-->
    <mu-dialog :open="dialog" title="" @close="closeNO">
      <div style="color:#666666 ; margin-bottom:1.5vh">
        您真的要删除这条收藏吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>
    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />

  </div>
</template>




<style lang="less" scoped="">
@import "../../assets/theme.less";



#greenfont {
  color: @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size:110%;
  
  .title{
    font-size:110%;
    color:#999999;
    font-weight:500;

    width:20%;
    div{
      margin-top:1vh;

    }
    text-align:left;
  }
  
  
  
}
</style>





<script>
export default {
  data() {

    return {
      // 弹出层
      toast: false,
      // 弹出标签 选择是否
      dialog: false,

      //  输入框初始化  
      UserEmail:'',
      FJM:'',
      YZM: '',
      //  输入框初始化  END  


      // 弹出层 弹出内容
      toast:false,
      TellUser:'',
      // 弹出层 弹出内容  END

    }
  },

  methods: {

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },



    //  获取验证码
    getYZM() {
      if(this.UserEmail =='')
      {
        this.TellUser='请输入您的邮箱';
        this.showToast();
      }
      else if (this.FJM =='')
      {
        this.TellUser='请输入附加码';
        this.showToast();
      }
    },
    //  获取验证码  END

    //  获取验证码
    Change() {
      if(this.UserEmail =='')
      {
        this.TellUser='请输入您的邮箱';
        this.showToast();
      }
      else if (this.FJM =='')
      {
        this.TellUser='请输入附加码';
        this.showToast();
      }
      else if (this.YZM =='')
      {
        this.TellUser='请输入收到的验证码';
        this.showToast();
      }
    },
    //  获取验证码  END


    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否




  }
}



</script>










// WEBPACK FOOTER //
// ChangePassWord.vue?15dbf840